import { render, staticRenderFns } from "./edit-form.vue?vue&type=template&id=816cd3b2&"
import script from "./edit-form.vue?vue&type=script&lang=js&"
export * from "./edit-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports